import { all, fork } from 'redux-saga/effects';
import rootHotelProfileConfigSaga from './hotelProfileConfig';
import rootRoomDetailConfigSaga from './roomDetailConfig';
import rootRateDetailConfigSaga from './rateDetailConfig';
import hotelListSaga from './hotelList';

export default function* rootAdminSaga() {
    yield all([
        fork(rootHotelProfileConfigSaga),
        fork(rootRoomDetailConfigSaga),
        fork(rootRateDetailConfigSaga),
        fork(hotelListSaga),
    ]);
}